
import { Vue, Component, Prop } from 'vue-property-decorator';
import btnConfirm from '../assets/btn-confirm.png';

/** 弹窗通用「确定」按钮 */
@Component
export default class ConfirmButton extends Vue {
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  btnConfirm = btnConfirm;

  onClick() {
    if (this.disabled) return;
    this.$emit('click');
  }
}
